<template>
  <v-dialog v-model="dialog" max-width="1400px" transition="dialog-bottom-transition" scrollable>
    <v-card class="grey lighten-5">
      <v-toolbar color="white" flat dense>
        <v-toolbar-title class="text-subtitle-1 font-weight-bold">Manage charts</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0">
        <v-container fluid class="pa-3">
          <v-row>
            <v-col
              v-for="(card, index) in localCards"
              :key="card.id"
              cols="12"
              md="4"
              class="d-flex"
            >
              <v-hover v-slot="{ hover }">
                <v-card
                  outlined
                  class="flex-grow-1 d-flex flex-column"
                  :class="{ 'selected-card': card.visible }"
                  @click="toggleCard(index)"
                  style="
                    cursor: pointer;
                    position: relative;
                    transition: all 0.2s;
                    height: 400px;
                    overflow: hidden;
                  "
                  elevation="0"
                  :style="
                    card.visible
                      ? `border: 2px solid ${$vuetify.theme.themes.light.secondary}`
                      : `border: 1px solid #e0e0e0; opacity: ${hover ? 1 : 0.5}`
                  "
                >
                  <!-- Overlay to prevent interaction with the chart inside the preview -->
                  <div
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                      z-index: 1;
                    "
                  ></div>

                  <div
                    v-if="!card.visible && hover"
                    class="d-flex align-center justify-center"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                      z-index: 2;
                    "
                  >
                    <v-btn color="primary" small class="text-none" outlined>
                      <v-icon left small>mdi-plus</v-icon>
                      Add Chart
                    </v-btn>
                  </div>

                  <div
                    v-if="card.visible && hover"
                    class="d-flex align-center justify-center"
                    style="
                      position: absolute;
                      top: 0;
                      left: 0;
                      width: 100%;
                      height: 100%;
                      z-index: 2;
                      background-color: rgba(255, 255, 255, 0.5);
                    "
                  >
                    <v-btn color="error" small class="text-none" outlined>
                      <v-icon left small>mdi-close</v-icon>
                      Delete chart
                    </v-btn>
                  </div>

                  <div class="pa-2 flex-grow-1" style="pointer-events: none">
                    <component
                      :is="card.component"
                      :component_name="component_name"
                      :cols="4"
                      :disable_filter="true"
                    />
                  </div>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="white pa-4">
        <v-spacer></v-spacer>
        <v-btn text small class="text-none" @click="close">Cancel</v-btn>
        <v-btn color="primary" small class="text-none" @click="save">Save Changes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import chartcarddistribution from '../common/chartCardDistribution'
  import chartcardpriceindex from '../common/charCardPriceIndex'
  import chartcardavailability from '../common/chartCardAvailability.vue'
  import chartcardpricingstatus from '../common/chartPricingStatus'

  export default {
    name: 'DashboardConfigModal',
    components: {
      chartcarddistribution,
      chartcardpriceindex,
      chartcardavailability,
      chartcardpricingstatus,
    },
    props: {
      value: Boolean,
      cards: Array,
      component_name: String,
    },
    data() {
      return {
        localCards: [],
      }
    },
    computed: {
      dialog: {
        get() {
          return this.value
        },
        set(val) {
          this.$emit('input', val)
        },
      },
    },
    watch: {
      value(val) {
        if (val) {
          // Deep copy to avoid mutating prop directly
          this.localCards = JSON.parse(JSON.stringify(this.cards))
        }
      },
    },
    methods: {
      close() {
        this.dialog = false
      },
      save() {
        this.$emit('save', this.localCards)
        this.close()
      },
      toggleCard(index) {
        this.localCards[index].visible = !this.localCards[index].visible
      },
    },
  }
</script>

<style scoped>
  .selected-card {
    background-color: #fff;
  }
  ::v-deep .v-card__text {
    min-height: 150px !important;
  }
</style>
